const normalizePackId = (value) => String(value || '').trim();

export const decorateOrdersWithPackGroups = (orders) => {
  const ordersByPackId = new Map();

  (orders || []).forEach((order) => {
    const packId = normalizePackId(order?.packId);
    if (order?.marketplace !== 'mercado_libre' || !packId) return;

    const group = ordersByPackId.get(packId) || [];
    group.push(order);
    ordersByPackId.set(packId, group);
  });

  return (orders || []).map((order) => {
    const packId = normalizePackId(order?.packId);
    // El pack es un concepto de Mercado Libre: una orden de otro canal que comparta
    // el mismo identificador no forma parte de esa compra.
    const group =
      packId && order?.marketplace === 'mercado_libre' ? ordersByPackId.get(packId) : null;
    if (!group || group.length < 2) {
      return { ...order, packGroup: null };
    }

    const orderIndex = group.findIndex((entry) => entry.id === order.id) + 1;
    return {
      ...order,
      packGroup: {
        packId,
        orderCount: group.length,
        orderIndex,
        isFirst: orderIndex === 1,
      },
    };
  });
};
